import { Component } from '@angular/core';

/**
 * Component which projects the content into the left side of the basic layout.
 * This is typically used for navigation or side menus.
 * Please use this component only within the `lvr-basic-layout` component.
 *
 * Example usage:
 * ```html
 * <lvr-basic-layout>
 *   <lvr-basic-layout-header> Header Content </lvr-basic-layout-header>
 *   <lvr-basic-layout-left> Left Side Content </lvr-basic-layout-left>
 *   <p>Main Content</p>
 * </lvr-basic-layout>
 * ```
 */
@Component({
	selector: 'lvr-basic-layout-left',
	template: `<ng-content></ng-content>`,
})
export class BasicLayoutLeftComponent {}
